<template lang="pug">
    div(:class="'context-'+context")
        include SearchProfessional.pug
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SearchProfessional',
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      searchType: "name",
      query: "",
      city: "",
    }
  },
  methods: {
    doSearch() {
      switch (this.searchType) {
        case "name":
          this.$router.push({
            name: "TrainerListByName",
            params: {
              encodedName: encodeURI(this.query),
            }
          })
          break;
        case "city":
          this.$router.push({
            name: "TrainerListByCity",
            params: {
              encodedCity: encodeURI(this.city),
            }
          })
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";

@import "SearchProfessional";

.context-colreps {
  @import 'SearchProfessionalColreps';
}

.context-mexreps {
  @import 'SearchProfessionalMexreps';
}

</style>



// WEBPACK FOOTER //
// src/components/search_professional/SearchProfessional.vue